var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paymentInfo"},[_c('base-form',{ref:"baseData",attrs:{"options":_vm.baseDataOptions,"rules":_vm.rules,"disabled":!_vm.canEdit,"label-width":"105px"},on:{"input":_vm.handleChangeBaseData},model:{value:(_vm.baseData),callback:function ($$v) {_vm.baseData=$$v},expression:"baseData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }